<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.gallery && localService.languageContent.table">
    <div class="banner center" style="max-width:800px;" *ngIf="wrapper">
        <div class="row freeze_height">
            <div class="col-4">
                <div style="float: left;margin-right: 10px;">
                    <app-file-upload *ngIf="isOpenFileUpload" (onFileUploaded)="onAction(6)" [forId]="receiptId"
                        [forId2]="businessId" [fileUploadFor]="FileUploadFor.Gallery"
                        [type]="GalleryType.ReceiptFile"></app-file-upload>
                </div>
                <label>{{localService.languageContent.gallery.cnt}}</label>
                <span class="en">&nbsp;:&nbsp;{{onGetText(2,'0')}}</span>
            </div>
            <div class="col-8" style="text-align: right;">
                <button *ngIf="!isDeleteEnabled" type="button" class="btn btn-primary" (click)="onAction(2)"
                    style="margin-right: 10px;margin-top: -3px;">
                    {{localService.languageContent.gallery.enable_delete}}
                </button>
                <label>{{localService.languageContent.gallery.size}}</label>
                <label class="en">&nbsp;(in MB)</label>
                <span class="en">&nbsp;:&nbsp;{{onGetText(1,'0')}}&nbsp;</span>
                <button class="button_icon danger icon_adjust" (click)="onAction(4)"
                    [disabled]="!isDeleteEnabled">delete_sweep</button>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-md-7">
                <div class="row">
                    <div class="col-4">
                        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(5)"
                            style="float: left; top: 0px !important;">arrow_back</button>
                        {{localService.languageContent.table.action}}
                    </div>
                    <div class="col-8">
                        {{localService.languageContent.gallery.title}}
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="row">
                    <div class="col-5">
                        {{localService.languageContent.gallery.format}}
                    </div>
                    <div class="col-7">
                        {{localService.languageContent.gallery.size}}
                        <span class="en">&nbsp;(in MB)</span>
                        <button class="button_icon button_icon_color icon_adjust" (click)="onLoad()"
                            style="float: right; top: 0px !important;">refresh</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngFor="let item of wrapper.items">
                <div class="row styled_row freeze_col" *ngIf="item.key != '0'">
                    <div class="col-md-7">
                        <div class="row">
                            <div class="col-4">
                                <button class="button_icon button_icon_color icon_adjust"
                                    (click)="onAction(3, item.key)">
                                    {{imageViewTypes.includes(item.v3) ? 'image' : 'link'}}
                                </button>
                                <button class="button_icon button_icon_color icon_adjust"
                                    (click)="localService.copyContent(item.v6)">
                                    content_copy
                                </button>
                            </div>
                            <div class="col-8">
                                <div *ngIf="!(editId && editId.length > 5 && editId == item.key)">
                                    <button class="button_icon icon_adjust button_icon_color"
                                        (click)="onAction(7, item.key)">edit</button>
                                    <span>
                                        {{item.v1 && item.v1.length > 0 ? item.v1: item.v2}}
                                    </span>
                                </div>
                                <div *ngIf="editId && editId.length > 5 && editId == item.key">
                                    <button class="button_icon button_icon_color icon_adjust"
                                        title="{{localService.languageContent.common.cancel}}"
                                        (click)="onAction(8)">cancel</button>
                                    <input autocomplete="off" type="text" [(ngModel)]="item.v7"
                                        style="width: calc(100% - 50px);"
                                        title="{{localService.languageContent.table.title}}"
                                        placeholder="{{localService.languageContent.table.title}}"
                                        id="{{elementIds.title + '-' + item.key}}" (keydown.enter)="onAction(9)" />
                                    <button class="button_icon button_icon_color icon_adjust"
                                        title="{{localService.languageContent.common.save}}"
                                        [disabled]="item.v1 == item.v7" (click)="onAction(9)">save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-5">
                                <div style="float: left;margin-right: 10px;">
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="onAction(1, item.key)">file_download</button>
                                </div>
                                <span class="en file_format">
                                    {{item.v3.toUpperCase()}}
                                </span>
                            </div>
                            <div class="col-7">
                                <div class="en number-only">
                                    <span>{{item.v4}}&nbsp;</span>
                                    <button class="button_icon danger icon_adjust" [disabled]="!isDeleteEnabled"
                                        (click)="onAction(4, item.key)">delete_sweep</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-otp-container *ngIf="isShowOtpPopup" [isShowRequestOtp]="true" [IsOtpPopup]="true"
        (onVerified)="onVerifiedOtp($event)" [businessId]="businessId" [otpType]="OtpType.DeleteBills"
        [interactionType]="interactionType" (onCancelled)="isShowOtpPopup = false"
        [requestOtpLabel]="localService.languageContent.common.request_otp" />
</div>